export default "__VITE_ASSET__9bbe221b__"